//------------with redux-persist----------
import React, { useEffect, useState, useContext } from 'react';
import './Home.css';
import ImageSlider from '../ImageSlider/ImageSlider';
import { BannerProvider } from '../ImageSlider/BannerProvider';
import CarousalProducts from '../ProductCarousal1/CarousalProducts';
import CustomerCare from '../CustomerCare/CustomerCare';
import SaleCountDown from '../SaleCountDown/SaleCountDown';
import { SaleCountdownProvider } from "../SaleCountDown/SaleCountdownProvider";
import FeaturedProduct from '../DashboardProduct/FeaturedProduct';
import TrendingProduct from '../DashboardProduct/TrendingProduct';
import { CollectionProvider } from '../DashboardProduct/GenericContext';

export default function Home() {

  
  return (
    <>
    
      <div className='image-slider-container'>
        <BannerProvider collectionName="banners">
          <ImageSlider />
        </BannerProvider>
      </div>

      <CarousalProducts />

      <SaleCountdownProvider>
        <SaleCountDown />
      </SaleCountdownProvider>

      <CollectionProvider collectionName="featuredProduct">
        <FeaturedProduct />
      </CollectionProvider>

      <CollectionProvider collectionName="trendingProduct">
        <TrendingProduct />
      </CollectionProvider>
      
      <CustomerCare />

    </>
  );
}









//------------------pure original-------------
//------------with redux-persist----------
// import React, { useEffect, useState, useContext } from 'react';
// import './Home.css';
// import ImageSlider from '../ImageSlider/ImageSlider';
// import { Link } from 'react-router-dom';
// import CarousalProducts from '../ProductCarousal1/CarousalProducts';
// import { useCart } from '../AddToCart/CartContext';
// import addtocarticon from '../Images/addtocarticon.png';
// import searchicon from '../Images/searchicon.png';
// import Searchproduct from '../SearchProduct/Searchproduct';
// import { topCollection, electronicCollection, homeImprovement } from '../ProductCarousal1/data';
// import { doubleproductlistData1, doubleproductlistData2 } from '../Only2ProductCarousal/data';
// import usericon from '../Images/usericon.png';
// import { useAuth } from '../firebase/AuthContext';

// import DataProvider from '../ProductCarousal1/DataProvider';
// import { DataContext } from '../ProductCarousal1/DataProvider';
// import { useSelector } from "react-redux";


// export default function Home() {


//   const {loading, loadingMore, loadMoreHomeImprovement, loadMoreElectronicCollection, loadMoreTopCollection, loadMoreOurCollection } = useContext(DataContext);
 
//   const {homeImprovement}= useSelector(
//   (state) => state.homeImprovement
//   );
//   const {electronicCollection}= useSelector(
//     (state) => state.electronicCollection
//     );
//   const {topCollection}= useSelector(
//     (state) => state.topCollection
//     );
//     const {ourCollection}= useSelector(
//       (state) => state.ourCollection
//       );
//     // const {homeImprovement}= useSelector(
//     //   (state) => state.homeImprovement
//     //   );


//   // Effect to automatically load more products when reaching the bottom of the page (optional)
//   useEffect(() => {
//     const observer = new IntersectionObserver(
//       (entries) => {
//         if (entries[0].isIntersecting) {
//           loadMoreHomeImprovement();
//           loadMoreElectronicCollection();
//           loadMoreTopCollection();
//           loadMoreOurCollection();
//         }
//       },
//       { threshold: 1.0 }
//     );

//     // const bottomHomeImprovement = document.getElementById("homeImprovement-bottom");
//     // const bottomElectronicCollection = document.getElementById("electronicCollection-bottom");
//     // const bottomTopCollection = document.getElementById("topCollection-bottom");

//     // if (bottomHomeImprovement) observer.observe(bottomHomeImprovement);
//     // if (bottomElectronicCollection) observer.observe(bottomElectronicCollection);
//     // if (bottomTopCollection) observer.observe(bottomTopCollection);

//     // return () => {
//     //   if (bottomHomeImprovement) observer.unobserve(bottomHomeImprovement);
//     //   if (bottomElectronicCollection) observer.unobserve(bottomElectronicCollection);
//     //   if (bottomTopCollection) observer.unobserve(bottomTopCollection);
//     // };
//   }, [loading, loadingMore]);






//   const { cartItemCount } = useCart();
//   const { handleUserNavigation } = useAuth();
  
//   return (
//     <>
//       <div className='home-page-container'>
//         <div className='search-product'>
//           <Searchproduct 
//           productData={[...topCollection,
//            ...electronicCollection,
//            ...homeImprovement, 
//            ...ourCollection, 
//            ...doubleproductlistData2]} />
//           {/* <Searchproduct productData={[...topCollection, ...electronicCollection, ...homeImprovement, ...doubleproductlistData1, ...doubleproductlistData2]} /> */}
//           {/* <img src={searchicon} alt="SearchIconError" style={{ width: '3.5vmax', height: '2.5vmax', marginBottom: '3.5px' }} /> */}
//         </div>

//         <div className='cart-login-icon'>

//           <Link to="/cart" className='cart-link'>
//             {cartItemCount > 0 && <span className="cart-count">{cartItemCount}</span>}
//             <img src={addtocarticon} alt="AddtoCartIconError" 
//             style={{ width: '4.2vmax', 
//             height: '3.5vmax', 
//             minWidth: '42px', 
//             minHeight: '30px' }} />
//           </Link>

//           <img src={usericon} alt="Login" onClick={handleUserNavigation} 
//           style={{ width: '6.2vmax', 
//           height: '4.5vmax', 
//           cursor: 'pointer', 
//           minWidth:'53px', 
//           minHeight:'38px' }} 
//           className='user-image' />
        
//         </div>

//       </div>

//       <div className='image-slider-container'>
//         {/* <DataProvider> */}
//           <ImageSlider />
//         {/* </DataProvider> */}

//       </div>


//       <CarousalProducts />

//     </>
//   );
// }









//-------------original-------------------
// import React, { useEffect, useState } from 'react';
// import './Home.css';
// import ImageSlider from '../ImageSlider/ImageSlider';
// import { Link } from 'react-router-dom';
// import CarousalProducts from '../ProductCarousal1/CarousalProducts';
// import { useCart } from '../AddToCart/CartContext';
// import addtocarticon from '../Images/addtocarticon.png';
// import searchicon from '../Images/searchicon.png';
// import Searchproduct from '../SearchProduct/Searchproduct';
// import { topCollection, electronicCollection, homeImprovement } from '../ProductCarousal1/data';
// import { doubleproductlistData1, doubleproductlistData2 } from '../Only2ProductCarousal/data';
// import usericon from '../Images/usericon.png';
// import { useAuth } from '../firebase/AuthContext';


// export default function Home() {
//   const { cartItemCount } = useCart();
//   const { handleUserNavigation } = useAuth();
  
//   return (
//     <>
//       <div className='Part2'>
//         <div style={{ display: 'flex' }}>
//           <Searchproduct productData={[...topCollection, ...electronicCollection, ...homeImprovement, ...doubleproductlistData1, ...doubleproductlistData2]} />
//           <img src={searchicon} alt="SearchIconError" style={{ width: '2.5vmax', height: '2vmax', marginBottom: '3.5px' }} />
//         </div>
//         <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
//           <Link to="/cart" className='link2'>
//             {cartItemCount > 0 && <span className="cart-count">{cartItemCount}</span>}
//             <img src={addtocarticon} alt="AddtoCartIconError" style={{ width: '3vmax', height: '2.5vmax' }} />
//           </Link>
//           <img src={usericon} alt="Login" onClick={handleUserNavigation} style={{ width: '5vmax', height: '3.5vmax', cursor: 'pointer' }} className='userimage' />
//         </div>
//       </div>

//       <div className='Part3'>
//         <ImageSlider />
//       </div>


//       <CarousalProducts />

//     </>
//   );
// }
